"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLineChartOptions = void 0;

var _accounting = _interopRequireDefault(require("accounting"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getLineChartOptions = function getLineChartOptions(data, dateFormat, valueFormat, goal, projection, tooltipFormat, xAxisFormat, yAxisFormat, height, xMin, ySoftMin, yTitle, legendEnabled) {
  function formatter() {
    return "".concat(tooltipFormat(this.point.y, this.point.x));
  }

  function positioner(labelWidth, labelHeight, point) {
    return {
      x: point.plotX + this.chart.plotLeft - 0.5 * labelWidth,
      y: point.plotY - labelHeight - 11
    };
  }

  var getDateTimeLabelFormats = function getDateTimeLabelFormats() {
    return xAxisFormat || dateFormat;
  };

  function getValueFormat() {
    var symbol = valueFormat.symbol,
        precision = valueFormat.precision,
        thousand = valueFormat.thousand,
        decimal = valueFormat.decimal,
        format = valueFormat.format;
    return _accounting.default.formatMoney(this.value, symbol, precision, thousand, decimal, format);
  }

  var series = data.map(function (_ref) {
    var name = _ref.name,
        data = _ref.data,
        type = _ref.type;
    return {
      type: type || projection ? 'line' : 'area',
      name: name,
      data: data
    };
  });

  if (goal.length > 0) {
    var goalOptions = _objectSpread(_objectSpread({}, _constants.defaultGoalOptions), {}, {
      data: [goal]
    });

    var durationOptions = _objectSpread(_objectSpread({}, _constants.defaultDurationOptions), {}, {
      data: [[-Infinity, 0], [goal[0], 0]]
    });

    series = [].concat(_toConsumableArray(series), [_objectSpread({}, goalOptions), _objectSpread({}, durationOptions)]);
  }

  var title = yTitle !== undefined && yTitle !== '' ? _objectSpread(_objectSpread({}, _constants.defaultLineChartOptions.yAxis.title), {}, {
    text: yTitle
  }) : false;
  return _objectSpread(_objectSpread({}, _constants.defaultLineChartOptions), {}, {
    chart: _objectSpread(_objectSpread({}, _constants.defaultLineChartOptions.chart), {}, {
      height: height,
      marginTop: yTitle !== undefined && yTitle !== '' ? 30 : 0
    }),
    xAxis: _objectSpread(_objectSpread({}, _constants.defaultLineChartOptions.xAxis), {}, {
      dateTimeLabelFormats: getDateTimeLabelFormats(),
      min: xMin
    }),
    yAxis: _objectSpread(_objectSpread({}, _constants.defaultLineChartOptions.yAxis), {}, {
      title: title,
      labels: {
        formatter: yAxisFormat !== null ? yAxisFormat : getValueFormat
      },
      softMin: ySoftMin
    }),
    legend: _objectSpread(_objectSpread({}, _constants.defaultLineChartOptions.legend), {}, {
      enabled: legendEnabled || projection
    }),
    tooltip: _objectSpread(_objectSpread({}, _constants.defaultLineChartOptions.tooltip), {}, {
      formatter: formatter,
      positioner: positioner
    }),
    series: _toConsumableArray(series)
  });
};

exports.getLineChartOptions = getLineChartOptions;